const TYPE_OPTIONS_BY_QUESTION_TYPE = {
  root: {
    learningOutcomes: {
      include: [ 'isDuplicate', 'hasDuplicates' ],
    },
    instructionalMethods: {
      include: [ 'isDuplicate', 'hasDuplicates' ],
    },
    topics: {
      include: [ 'isDuplicate', 'hasDuplicates' ],
    },
    components: {
      include: [ 'isDuplicate', 'hasDuplicates' ],
    },
    degreeMaps: {
      include: [ 'isDuplicate', 'hasDuplicates' ],
    },
    specializations: {
      include: [ 'isDuplicate', 'hasDuplicates' ],
    },
  },
  direct: {
  },
}

module.exports = {
  TYPE_OPTIONS_BY_QUESTION_TYPE,
}
